import React from 'react';
import Grid from '../../../../../muiComponents/Grid';
import GridChild from '../../../../../muiComponents/GridChild';
import {
    full_ColumnGrid,
    gridSpacing30,
} from '../../../../../utils/commonVariables/grid';
import {
    AttributeDefinitionState,
    AttributeValueState,
} from '../../../types/zitoneoServicesTypes';
import { getGridChildSize } from '../../../utils/zitoneoServicesUtils';
import InputFieldFactory from './InputFieldFactory';

interface ServiceAttributesProps {
    serviceId: string;
    attributeDefinitions?: AttributeDefinitionState[];
    attributeValues?: AttributeValueState[];
    disabled: boolean;
    onChange: (
        id: string,
        value: string,
        idService: string,
        idAttributeDefinition: number
    ) => void;
    onDelete: (id: string, idService: string) => void;
}

const ServiceAttributes = ({
    serviceId,
    attributeDefinitions = [],
    attributeValues = [],
    disabled,
    onChange,
    onDelete,
}: ServiceAttributesProps) => {
    return (
        <Grid
            columnSpacing={gridSpacing30}
            rowSpacing={gridSpacing30}
            style={{ width: 'unset' }}
        >
            {attributeDefinitions.map(attribute => {
                const savedAttributeValues = attributeValues.filter(
                    attributeValue =>
                        attributeValue.IdAttributeDefinition ===
                        attribute.IdAttributeDefinition
                );

                return (
                    <GridChild
                        key={attribute.Id}
                        gridProps={
                            attribute.Unique
                                ? getGridChildSize(attribute.SizeKey)
                                : full_ColumnGrid
                        }
                    >
                        <InputFieldFactory
                            idService={serviceId}
                            values={savedAttributeValues}
                            attributeDefinition={attribute}
                            disabled={disabled}
                            onChange={onChange}
                            onDelete={onDelete}
                        />
                    </GridChild>
                );
            })}
        </Grid>
    );
};

export default ServiceAttributes;
